"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const classnames_1 = __importDefault(require("classnames"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Menu_1 = __importDefault(require("@mui/material/Menu"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const Table_1 = __importDefault(require("@mui/material/Table"));
const TableBody_1 = __importDefault(require("@mui/material/TableBody"));
const TableCell_1 = __importDefault(require("@mui/material/TableCell"));
const TableContainer_1 = __importDefault(require("@mui/material/TableContainer"));
const TableRow_1 = __importDefault(require("@mui/material/TableRow"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Check_1 = __importDefault(require("@mui/icons-material/Check"));
const MoreVert_1 = __importDefault(require("@mui/icons-material/MoreVert"));
const Alert_1 = __importDefault(require("@mui/material/Alert"));
const rootUiActions_1 = require("companion-app-components/flux/root-ui/rootUiActions");
const dataset_shares_1 = require("companion-app-components/flux/dataset-shares");
const datasets_1 = require("companion-app-components/flux/datasets");
const core_1 = require("companion-app-components/utils/core");
const actions_1 = require("components/Dialogs/DatasetSharing/actions");
const constants_1 = require("utils/constants");
const warning_svg_1 = __importDefault(require("assets/warning.svg"));
const styles_1 = __importDefault(require("./styles"));
const utils_1 = require("./utils");
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const TableSharedDatasets = ({ datasets, currentDataset, hoveredDataset, datasetsSharing, setHoveredDataset, handleLogout, onDatasetClick, }) => {
    const entitledDatasets = (0, react_redux_1.useSelector)((state) => datasets_1.datasetsSelectors.getEntitledDatasets(state));
    const dispatch = (0, react_redux_1.useDispatch)();
    const { classes } = useStyles();
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const open = Boolean(anchorEl);
    const handleRemoveDialog = () => {
        dispatch((0, rootUiActions_1.removeDialog)(actions_1.DIALOG_TYPE_CONFIRMATION_NEW));
    };
    const handleMenuClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
        setHoveredDataset(undefined);
    };
    const handleExitAndClose = () => {
        handleMenuClose();
        dispatch((0, actions_1.showConfirmationDialog)({
            heading: 'Leave Shared Access',
            subHead: `Leave shared access "${(hoveredDataset === null || hoveredDataset === void 0 ? void 0 : hoveredDataset.name) || ''}"?`,
            description: 'You will no longer be able to access this dataset unless it is shared with you again.',
            buttons: [
                {
                    label: 'CANCEL',
                    variant: 'outlined',
                    action: handleRemoveDialog,
                },
                {
                    label: 'LEAVE',
                    variant: 'outlined',
                    action: () => {
                        handleRemoveDialog();
                        const datasetShare = datasetsSharing === null || datasetsSharing === void 0 ? void 0 : datasetsSharing.find((objDatasetSharing) => objDatasetSharing.datasetId === (hoveredDataset === null || hoveredDataset === void 0 ? void 0 : hoveredDataset.id));
                        if (datasetShare) {
                            dispatch(dataset_shares_1.datasetSharesActions.deleteDatasetShare(datasetShare));
                            core_1.tracker.track(core_1.tracker.events.datasetSharing, { property: 'removeSharedAccount' });
                        }
                        if ((hoveredDataset === null || hoveredDataset === void 0 ? void 0 : hoveredDataset.id) === (currentDataset === null || currentDataset === void 0 ? void 0 : currentDataset.id)) {
                            setTimeout(() => handleLogout(), 1000);
                        }
                    },
                },
            ],
        }));
    };
    return (<Box_1.default sx={{ maxHeight: 300 }}>
      <TableContainer_1.default>
        <Table_1.default aria-label="my cloud accounts table">
          <TableBody_1.default>
            {datasets && datasets.valueSeq().map((objDataset) => {
            const hasValidEntitlement = entitledDatasets.get(objDataset.id);
            return (<TableRow_1.default key={objDataset.id} onMouseOver={() => setHoveredDataset(objDataset)} onMouseLeave={() => {
                    if (!anchorEl) {
                        setHoveredDataset(undefined);
                    }
                }} onClick={() => hasValidEntitlement && onDatasetClick(objDataset)} sx={{
                    backgroundColor: hoveredDataset === objDataset ? 'babyBlue' : null,
                    cursor: hasValidEntitlement ? 'pointer' : 'not-allowed',
                }}>
                  <TableCell_1.default component="th" sx={{ p: 0 }}>
                    <TableRow_1.default>
                      <TableCell_1.default component="th" sx={{
                    p: 0,
                    width: '1%',
                    borderBottom: 'none',
                }}>
                        <Check_1.default fontSize="small" color="success" sx={{
                    visibility: currentDataset === objDataset ? 'visible' : 'hidden',
                }}/> 
                      </TableCell_1.default>
                      <TableCell_1.default component="th" scope="row" sx={{
                    width: '63%',
                    maxWidth: 200,
                    borderBottom: 'none',
                }}>
                        <Typography_1.default variant="body1">
                          {objDataset.name}
                        </Typography_1.default>
                        <Typography_1.default variant="body2" color="text.secondary">
                          {`Owner: ${(0, utils_1.getOwnerName)(objDataset.grantorFirstName, objDataset.grantorLastName)}`}
                        </Typography_1.default>
                      </TableCell_1.default>
                      <TableCell_1.default component="th" align="right" sx={{
                    width: '30%',
                    borderBottom: 'none',
                }}>
                        <Typography_1.default variant="body2" color="text.secondary" component="span" mr={2}>
                          Last Synced: {objDataset.lastSyncedAt ? (0, utils_1.formatLastSyncedDate)(objDataset.lastSyncedAt) : constants_1.APP_STRING_NOT_APPLICABLE}
                        </Typography_1.default>
                      </TableCell_1.default>
                      <TableCell_1.default component="th" sx={{
                    borderBottom: 'none',
                    textAlign: 'right',
                }}>
                        <IconButton_1.default onClick={handleMenuClick}>
                          <MoreVert_1.default fontSize="small"/>
                        </IconButton_1.default>
                      </TableCell_1.default>
                    </TableRow_1.default>
                    {!hasValidEntitlement &&
                    <TableRow_1.default>
                        <TableCell_1.default colSpan={6} sx={{
                            p: 0,
                            m: 0,
                            borderBottom: 'none',
                        }}>
                          <Alert_1.default icon={<img src={warning_svg_1.default} alt="alert" height={24} width={24}/>} className={(0, classnames_1.default)(classes.alert, classes.sharedTableAlert)}>
                            Owner subscription expired 
                          </Alert_1.default>
                        </TableCell_1.default>
                      </TableRow_1.default>}
                  </TableCell_1.default>
                </TableRow_1.default>);
        })}
          </TableBody_1.default>
        </Table_1.default>
      </TableContainer_1.default>
      <Menu_1.default id="shared-dataset-menu" anchorEl={anchorEl} open={open} onClose={handleMenuClose} slotProps={{
            paper: {
                style: {
                    width: '28ch',
                },
            },
        }}>
        <MenuItem_1.default onClick={handleExitAndClose} sx={{
            '&:hover': {
                backgroundColor: 'babyBlue',
            },
        }}>
          Leave shared access
        </MenuItem_1.default>
      </Menu_1.default>
    </Box_1.default>);
};
exports.default = TableSharedDatasets;
